export const enum HomePageAction {}

export const enum HomePageMutation {
  setPlayedChannelIndex = "setPlayedChannelIndex"
}

export const enum HomePageGetter {
  GetPlayedChannelIndex = "GetPlayedChannelIndex"
}
export interface HomePageState {
  playedChannelIndex?: number;
}
